import React, { useState } from "react";
import closedarkicon from "../../images/closedark.svg";
import saveicon from "../../images/save.svg";
import createProjecticon from "../../images/createProject.svg";
import { createProject } from "api/project.api";
import { doGetProjectsList } from "store/slices/projectSlice";
import { useAppDispatch } from "hooks/reduxHooks";
import SingleTitleWithSearch from "components/Common/SearchableHiringCompany/SearchableHiringCompany";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import SearchableSkills from "components/Common/SearchableSkills/SearchableSkills";
import { Button, Flex, Form, Input, InputNumber, notification, Select, Space } from "antd";
import { DollerIcon } from "Icon/Icon";
import UploadFile from "components/Common/Input/UploadFile";
import { UploadChangeParam } from "antd/es/upload";
import MultiSkillSelector from "components/Select/MultiSkillSelector";
import EmploymentSelect from "components/Common/Employment/EmploymentSelect";
import GoogleLocationWithDropdown from "components/Common/SearchableDropdown/GoogleLocationWithDropdown";
import Label from "components/Common/Label/Label";
import SearchableJobTitle from "components/Common/SearchableHiringCompany/SearchableJobTitle";
import { setSelectedProject } from "store/slices/searcSlice";

interface ProjectFormValues {
  projectName: string;
  official_title: string;
  hiringCompany: string;
  location: string;
  radius: number;
  salary: number;
  employment: any;
  description: string;
  skills: any;
  file: File | null;
  currency: any;
  minimum_salary: number;
  maximum_salary: number;
}

interface CreateProjectPopupProps {
  onCancel: () => void;
}

const CreateProject: React.FC<CreateProjectPopupProps> = ({ onCancel }) => {
  const [formValues, setFormValues] = useState<ProjectFormValues>({
    projectName: "",
    official_title: "",
    hiringCompany: "",
    location: "",
    radius: 0,
    salary: 0,
    employment: "",
    description: "",
    skills: [],
    file: null,
    currency: "USD",
    minimum_salary: 0,
    maximum_salary: 0,
  });
  const [form] = Form.useForm();
  console.log(formValues, "formValues");

  const { Option } = Select;

  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);

  const dispatch = useAppDispatch();

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null; // Set to null if undefined
    setFormValues({ ...formValues, file });
  };
  console.log(formValues, "formValuesformValues");
  const draggerProps = {
    name: "file",
    multiple: false,
    accept: ".svg,.png,.jpg,.jpeg,.gif",
    onChange(info: UploadChangeParam) {
      const file = info.fileList[0]?.originFileObj ?? null; // Get the first file or set to null
      setFormValues({ ...formValues, file });
    },
    beforeUpload: () => false, // Prevent auto upload, if needed
  };

  const handleSkillChange = (skills: string[]) => {
    setFormValues({ ...formValues, skills });
  };

  const handleSubmit = async (formValues: any) => {
    if (formValues.minimum_salary >= formValues.maximum_salary) {
      form.setFields([
        {
          name: "maximum_salary",
          errors: ["Maximum salary must be greater than minimum salary."],
        },
      ]);
      return;
    }
    const formData = new FormData();
    formData.append("title", formValues.projectName);
    formData.append("recruiting_company", formValues.hiringCompany);
    formData.append("locations", formValues.location ? formValues.location : JSON.stringify([]));
    formData.append("official_title", formValues.official_title);
    formData.append("radius", formValues.radius.toString());
    formData.append("minimum_salary", formValues.minimum_salary.toString());
    formData.append("maximum_salary", formValues.maximum_salary.toString());
    formData.append("job_type", formValues.employment);
    formData.append("description", formValues.description);
    formData.append(
      "keywords",
      formValues.skills ? JSON.stringify(formValues.skills) : JSON.stringify([])
    ); // Skills can be stringified as JSON
    formData.append("currency", formValues.currency || "USD");

    if (formValues.file) {
      formData.append("job_description", formValues.file);
    }

    try {
      const response = await createProject(formData);

      dispatch(setSelectedProject(response));
      onCancel();
      notification.success({
        message: "Success",
        description: "Project created successfully",
      });
      // Optionally, reset form or provide feedback to user

      // onCancel();
    } catch (error) {
      notification.error({
        message: "Failed",
        description: "Failed to create project!",
      });
      // Handle the error, show error message to user, etc.
    }
  };

  const selectAfter = (
    <Select
      defaultValue="USD"
      style={{ width: 60 }}
      value={formValues.currency}
      onChange={(value) => setFormValues({ ...formValues, currency: value })}
    >
      <Option value="USD">$</Option>
      <Option value="EUR">€</Option>
      <Option value="GBP">£</Option>
    </Select>
  );
  const handleCityChange = (selected: string[] | string) => {
    const lastSelectedValue = Array.isArray(selected) ? selected[selected.length - 1] : selected;
    setSelectedLocation(lastSelectedValue);
    form.setFieldsValue({ location: lastSelectedValue });
  };

  const handlePosition = (position: string) => {
    setFormValues({ ...formValues, official_title: position });
  };

  const handleHighringCompany = (company: string) => {
    form.setFieldsValue({ hiringCompany: company });
  };

  const handleChange = (field: keyof ProjectFormValues, value: any) => {
    setFormValues({ ...formValues, [field]: value });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center">
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-sm"></div>

      <div
        className="relative bg-white rounded-lg shadow-md"
        style={{ width: "814px", height: "550px" }}
      >
        <div className="flex justify-between h-20 bg-bg-light-primary rounded-t-lg p-3 border-b-2 focus:border-border-theme ">
          <div className="flex gap-2">
            <button className="p-2 shadow-custom rounded-md w-9 h-9 bg-toggle-switch-bg mt-2">
              <img src={createProjecticon} alt="Create Project" />
            </button>
            <div className="items-center justify-between mt-1">
              <h2 className="text-md font-semibold">Create a Project</h2>
              <p className="text-xs text-gray-600">
                Create a project to be able to use AI assistant
              </p>
            </div>
          </div>

          <button onClick={onCancel} className="p-2 rounded-md w-8 h-8 hover:bg-white">
            <img src={closedarkicon} alt="Close" />
          </button>
        </div>

        <Form form={form} name="register" onFinish={handleSubmit} scrollToFirstError>
          <div
            className="grid grid-cols-1 md:grid-cols-2 overflow-y-auto"
            style={{ height: "calc(550px - 9rem)" }}
          >
            <div className="space-y-3 text-xs  text-text-tertiary pt-6 px-3">
              <Form.Item
                name="projectName"
                rules={[{ required: true, message: "Please enter the project name" }]}
                className="mb-5"
              >
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label labelTitle="Project Name" isHelpIconRequired={false} isRequired={true} />
                  <Input
                    placeholder="Enter Name"
                    rootClassName="py-2 px-3"
                    className="rounded-lg "
                    size="large"
                  />
                </Space>
              </Form.Item>
              <Form.Item
                style={{ width: "100%" }}
                name="official_title"
                rules={[{ required: true, message: "Please enter the position title." }]}
                className="mb-5"
              >
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label
                    labelTitle="Position"
                    isHelpIconRequired={true}
                    isRequired={true}
                    tooltipText="The specific job title you will be sourcing for."
                  />
                  <SearchableJobTitle
                    placeholder="Position"
                    onChange={(title: any) => {
                      form.setFieldValue("official_title", title);
                    }}
                  ></SearchableJobTitle>
                </Space>
              </Form.Item>
              <Form.Item
                name="hiringCompany"
                rules={[{ required: true, message: "Please select a hiring company" }]}
                className="mb-5"
              >
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label
                    labelTitle="Hiring Company"
                    isHelpIconRequired={true}
                    isRequired={true}
                    tooltipText="Hiring Company"
                  />
                  <SingleTitleWithSearch
                    placeholder="Start Typing"
                    onChange={(value: string) => {
                      handleHighringCompany(value);
                    }}
                  />
                </Space>
              </Form.Item>
              <div className="flex p-0">
                {" "}
                <Form.Item
                  name="location"
                  rules={[{ required: true, message: "Please select a location" }]}
                  className="w-3/4 m-0 mr-4"
                >
                  <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                    <Label labelTitle="Location" isHelpIconRequired={false} isRequired={true} />
                    <GoogleLocationWithDropdown
                      handleChange={handleCityChange}
                      selectedLocations={selectedLocation}
                      placeholder={"Search for a location..."}
                      isBorder={false}
                    />
                  </Space>
                </Form.Item>
                <Form.Item name="radius" className="w-1/4 m-0">
                  <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                    <Label labelTitle="Radius(ml)" isHelpIconRequired={false} isRequired={true} />
                    <Input
                      type="number"
                      placeholder="0"
                      rootClassName="py-2 px-3"
                      className="rounded-lg"
                    />
                  </Space>
                </Form.Item>
              </div>
              <Space direction="vertical" size={"small"} className="w-full gap-[6px] mb-5">
                <Label labelTitle="Salary" isHelpIconRequired={false} isRequired={true} />
                <Flex gap={10} className="w-full">
                  <Form.Item
                    name="minimum_salary"
                    rules={[{ required: true, message: "Please enter the minimum salary" }]}
                    style={{ flex: 1 }}
                  >
                    <InputNumber
                      addonAfter={selectAfter}
                      placeholder="Min salary"
                      size="large"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="maximum_salary"
                    rules={[{ required: true, message: "Please enter the maximum salary" }]}
                    style={{ flex: 1 }}
                  >
                    <InputNumber
                      size="large"
                      addonAfter={selectAfter}
                      placeholder="Max salary"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Flex>
              </Space>
              <Form.Item
                name="employment"
                rules={[{ required: true, message: "Please select employment type" }]}
                className="mb-5"
              >
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label labelTitle="Employment" isHelpIconRequired={false} isRequired={true} />
                  <EmploymentSelect
                    onChange={(value) => {
                      form.setFieldsValue({ employment: value });
                    }}
                  ></EmploymentSelect>
                </Space>
              </Form.Item>
            </div>
            <div className="space-y-3 text-xs  text-text-tertiary pt-6 px-3">
              <Form.Item
                name="description"
                rules={[{ required: true, message: "Please enter a description" }]}
                className="mb-5"
              >
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label labelTitle="Description" isHelpIconRequired={false} isRequired={true} />
                  <Input.TextArea
                    placeholder="Enter a Description..."
                    rootClassName="py-2 px-3"
                    className="rounded-lg"
                    rows={8}
                  />
                </Space>
              </Form.Item>

              <Form.Item name="upload" className="mb-5">
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label labelTitle="Upload" isHelpIconRequired={false} isRequired={true} />
                  <UploadFile {...draggerProps} secText="PDF and Docx files supported" />
                </Space>
              </Form.Item>

              <Form.Item
                name="skills"
                rules={[{ required: true, message: "Please select skills" }]}
              >
                <Space direction="vertical" size="small" className="w-full gap-[6px]">
                  <Label
                    labelTitle="Skills"
                    isHelpIconRequired={true}
                    isRequired={true}
                    tooltipText="Skills"
                  />
                  <MultiSkillSelector
                    placeholder="eg: React.js"
                    skills={form.getFieldValue("skills") || []} // Ensure `skills` is an array
                    rootClassName={
                      (form.getFieldValue("skills")?.length || 0) > 0 ? "border-primary" : ""
                    }
                    handleDeselect={(deselectedSkill: string) => {
                      const currentSkills = form.getFieldValue("skills") || [];
                      form.setFieldsValue({
                        skills: currentSkills.filter((skill: string) => skill !== deselectedSkill),
                      });
                    }}
                    onChange={(selectedSkills: any) => {
                      const skillLabels = selectedSkills.map((skill: any) => skill?.value);
                      form.setFieldsValue({ skills: skillLabels });
                    }}
                  />
                </Space>
              </Form.Item>
            </div>
          </div>
          <div className="col-span-2 flex items-center justify-between text-sm px-6 h-16">
            <div className="flex space-x-2 ml-auto">
              <button
                type="button"
                className="flex items-center gap-2 text-xs font-medium text-secondary py-1 px-2 rounded"
                onClick={onCancel}
              >
                <img src={closedarkicon} alt="Close" className="w-4 h-4" />
                <span>Cancel</span>
              </button>
              <Button
                type="primary"
                htmlType="submit"
                className="text-white py-1 px-3 rounded-md bg-[#845dda] border border-[#7F56D9]"
                // className="bg-primary text-white py-1 px-3 rounded-md text-base  h-11 hover:bg-[#7F56D9]"
              >
                Save Project
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CreateProject;
